import { API, API_GET_ID } from "../../Config";

export const GetRecentUser = () => {
  return API_GET_ID(API.RecentUser);
};
